// @flow

import moment from 'moment';
import _ from 'lodash/number';
import { logError } from './Logger';
import { setLocalStorageItem, getLocalStorageItem } from '../libs/LocalStorage';
import { START_UPDATE_TIME, END_UPDATE_TIME } from '../../../config';

let version = getLocalStorageItem('latestVersion');

async function getLatestVersion() {
  try {
    const response = await fetch('/version.json');
    const result = await response.json();
    return result.version.buildDate;
  } catch (error) {
    logError(error);
    throw new Error(`Version request failed: ${error}`);
  }
}

async function reloadIfNewVersion() {
  const env = process.env.NODE_ENV;
  if (env && env !== 'development') {
    const latestVersion = await getLatestVersion();

    if (version !== latestVersion) {
      version = latestVersion;
      setLocalStorageItem('latestVersion', latestVersion);
      location.reload(true);
    }
  }
}

export function getDelayInSecond(min: string, max: string) {
  let delay;
  const day = 24 * 60 * 60;

  const currentDate = moment().unix();

  const minHour = min.split(':')[0];
  const minMinutes = min.split(':')[1];

  const maxHour = max.split(':')[0];
  const maxMinutes = max.split(':')[1];
  // eslint-disable-next-line
  const startDate = max < min ? moment().add(-1, 'days').hour(minHour).minute(minMinutes).unix() : moment().hour(minHour).minute(minMinutes).unix();
  const endDate = moment().hour(maxHour).minute(maxMinutes).unix();

  if (_.inRange(currentDate, endDate, startDate)) {
    delay = 24 * 60 * 60;
  } else {
    let randomTimeInUpdateSpan;
    randomTimeInUpdateSpan = _.random(startDate, endDate);
    if (randomTimeInUpdateSpan < moment().hour('00').minute('00').unix()) {
      randomTimeInUpdateSpan += day;
    }
    delay = randomTimeInUpdateSpan - currentDate;
    if (delay < 0) {
      delay += day;
    }
  }
  return delay;
}


export function setPollForNewVersionDelay() {
  const delayInMS = getDelayInSecond(START_UPDATE_TIME, END_UPDATE_TIME) * 1000;
  setTimeout(() => {
    reloadIfNewVersion();
  }, delayInMS);
}



// WEBPACK FOOTER //
// ./src/js/libs/VersionCheck.js